// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1748":"6f23bcb2","2015":"62030658","5152":"b69c9285","5520":"a60ccc05","5725":"6f23bcb2","6855":"6f23bcb2","8169":"a60ccc05","8655":"6f23bcb2","9076":"6f23bcb2"}[chunkId] + ".chunk.css";
};